import { render, staticRenderFns } from "./ChangeEmailPage.vue?vue&type=template&id=3387f8be&"
import script from "./ChangeEmailPage.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports